import { requestSuccess } from "@Api";
import { SET_DRAFT, CLEAR_DRAFT } from "@Actions/types";

export const setDraft = (data) => {
	return (dispatch) => {
		dispatch(requestSuccess(SET_DRAFT, data));
	};
};

export const clearDraft = () => {
	return (dispatch) => {
		dispatch(requestSuccess(CLEAR_DRAFT));
	};
};
